var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplatesMobileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document Fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.4688 7.03125C14.5641 7.03125 13.8281 6.29527 13.8281 5.39062V0H5.4375C4.01592 0 2.85938 1.15655 2.85938 2.57812V21.4219C2.85938 22.8435 4.01592 24 5.4375 24H18.5625C19.9841 24 21.1406 22.8435 21.1406 21.4219V7.03125H15.4688ZM6.70312 16.875H10.1119C10.5002 16.875 10.815 17.1898 10.815 17.5781C10.815 17.9664 10.5002 18.2812 10.1119 18.2812H6.70312C6.31481 18.2812 6 17.9664 6 17.5781C6 17.1898 6.31481 16.875 6.70312 16.875ZM6 13.8281C6 13.4398 6.31481 13.125 6.70312 13.125H17.0156C17.4039 13.125 17.7188 13.4398 17.7188 13.8281C17.7188 14.2164 17.4039 14.5312 17.0156 14.5312H6.70312C6.31481 14.5312 6 14.2164 6 13.8281ZM17.0156 9.375C17.4039 9.375 17.7188 9.68981 17.7188 10.0781C17.7188 10.4664 17.4039 10.7812 17.0156 10.7812H6.70312C6.31481 10.7812 6 10.4664 6 10.0781C6 9.68981 6.31481 9.375 6.70312 9.375H17.0156Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.2344 5.39052C15.2344 5.51975 15.3395 5.62489 15.4688 5.62489H20.8272C20.6986 5.38743 20.5331 5.16932 20.3343 4.98121L15.8145 0.705176C15.6391 0.539238 15.4437 0.400816 15.2344 0.291504V5.39052H15.2344Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplatesMobileIcon);
export default __webpack_public_path__ + "static/media/templates-mobile-icon.708d34f2fb13668d3a0b7916afdf1edc.svg";
export { ForwardRef as ReactComponent };